module.exports = __webpack_public_path__ + "img/symbol_3.722439f0.png";